<!-- <div [ngClass]="props.isAutoComplete ? 'autocomplete' : (props.isSwitchInput ? 'form-check form-switch' : '')"
  *ngIf="!props.propIsHidden">
  <div class="form-check form-switch switch">
   
    <input class="checkbox " role="switch" [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" type="checkbox"
      [id]="props.id" [formControlName]="props.field_Name" (change)="toggleEmitter($event)" [checked]="props.value"
      [disabled]="props.readOnly" />
      <label class="switch" for="{{ props.field_Name }}">{{ props.label }}</label>
  </div>
</div> -->

<!-- <div *ngIf="!props.propIsHidden" [ngClass]="props.isAutoComplete ? 'autocomplete' : (props.isSwitchInput ? 'form-check form-switch' : '')">
  <div class="form-check form-switch d-flex">
    <label class="form-check-label" [for]="props.id">{{ props.label }}</label>
    <input 
      class="form-check-input" 
      role="switch" 
      [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" 
      type="checkbox"
      [id]="props.id" 
      [formControlName]="props.field_Name" 
      (change)="toggleEmitter($event)" 
     
      [disabled]="props.readOnly" 
    />
    
  </div>
</div> -->

<div class="d-flex  form-check form-switch" *ngIf="!props.propIsHidden"
  [ngClass]="props.isAutoComplete ? 'autocomplete' : (props.isSwitchInput ? 'form-check form-switch' : '')">
  <div class="mr-4"> <label class="" [for]="props.id">{{ props.label }}</label>
  </div>
  <div class="mx-4">
    <input class="form-check-input" role="switch" [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" type="checkbox"
      [id]="props.id" [formControlName]="props.field_Name" (change)="toggleEmitter($event)"
      [disabled]="props.readOnly" />
  </div>



</div>